/**
 * メインビジュアル（.p-mv）または下層ページの .p-lower-head が
 * ビューポートから外れたらヘッダーに _is-active を付与する
 * （トップは .p-mv を優先）
 */
export function headerMv() {
  const header = document.getElementById("js-header");
  const mv = document.querySelector(".p-mv");
  const lowerHead = document.querySelector(".p-lower-head");
  const target = mv || lowerHead;

  if (!header || !target) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          header.classList.remove("_is-active");
        } else {
          header.classList.add("_is-active");
        }
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(target);
}
